import authorizedAPIInstance from '@/api/authorizedAPI';

import type {
  BulkImportFilesListResponseDTO,
  BulkImportFilesParams,
  BulkImportFilesResponse,
} from '../types/bulkImportsHistory.types';
import { mapBulkImportFilesResponse } from '../utils/bulkImportsHistory.mapper';

export const getBulkImportFilesList = async (
  params: BulkImportFilesParams
): Promise<BulkImportFilesResponse> => {
  const { data } =
    await authorizedAPIInstance.get<BulkImportFilesListResponseDTO>(
      '/soft-tag/bulk-import/files',
      {
        params,
      }
    );

  return mapBulkImportFilesResponse(data);
};

export const getBulkImportFileReport = async (
  fileId: number
): Promise<string> => {
  const { data } = await authorizedAPIInstance.get<string>(
    `/soft-tag/bulk-import/${fileId}/report`,
    {
      headers: {
        Accept: 'text/csv',
      },
      responseType: 'text',
    }
  );

  return data;
};
